// ══════════════════════════════════
// MECA Shopify Theme — JavaScript
// ══════════════════════════════════

document.addEventListener('DOMContentLoaded', function() {

  // ── Scroll animations (faster stagger) ──
  var animateEls = document.querySelectorAll('.animate-in');
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.style.animationPlayState = 'running';
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    animateEls.forEach(function(el) {
      el.style.animationPlayState = 'paused';
      obs.observe(el);
    });
  } else {
    animateEls.forEach(function(el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
  }

  // ── Product image gallery ──
  var thumbs = document.querySelectorAll('[data-thumb]');
  var mainImg = document.getElementById('mainImage');
  if (thumbs.length && mainImg) {
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        mainImg.src = this.dataset.full;
        thumbs.forEach(function(t) { t.style.borderColor = 'transparent'; });
        this.style.borderColor = 'var(--brand)';
      });
    });
  }

  // ── AJAX Add to Cart with drawer ──
  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var formData = new FormData(productForm);
      var submitBtn = productForm.querySelector('[type="submit"]');
      var originalText = submitBtn.textContent;
      submitBtn.textContent = 'Adding...';
      submitBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function(res) { return res.json(); })
      .then(function(item) {
        submitBtn.textContent = 'Added ✓';
        setTimeout(function() {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        }, 1500);
        // Update cart count in header
        updateCartCount();
        // Open cart drawer
        openCartDrawer();
      })
      .catch(function() {
        submitBtn.textContent = 'Error — try again';
        submitBtn.disabled = false;
        setTimeout(function() { submitBtn.textContent = originalText; }, 2000);
      });
    });
  }

  // ── Cart drawer ──
  function updateCartCount() {
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        document.querySelectorAll('.cart-badge').forEach(function(badge) {
          if (cart.item_count > 0) {
            badge.textContent = cart.item_count;
            badge.style.display = 'flex';
          } else {
            badge.style.display = 'none';
          }
        });
      })
      .catch(function() {});
  }

  function openCartDrawer() {
    var overlay = document.getElementById('cartDrawerOverlay');
    var drawer = document.getElementById('cartDrawer');
    if (!overlay || !drawer) return;

    // Fetch cart and render
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        renderCartDrawer(cart);
        overlay.classList.add('open');
        drawer.classList.add('open');
        document.body.style.overflow = 'hidden';
      });
  }

  function closeCartDrawer() {
    var overlay = document.getElementById('cartDrawerOverlay');
    var drawer = document.getElementById('cartDrawer');
    if (!overlay || !drawer) return;
    overlay.classList.remove('open');
    drawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  function renderCartDrawer(cart) {
    var itemsContainer = document.getElementById('cartDrawerItems');
    var footer = document.getElementById('cartDrawerFooter');
    if (!itemsContainer || !footer) return;

    if (cart.items.length === 0) {
      itemsContainer.innerHTML = '<p style="text-align:center;color:var(--text-muted);padding:40px 0;font-size:14px;">Your cart is empty</p>';
      footer.innerHTML = '';
      return;
    }

    var html = '';
    cart.items.forEach(function(item) {
      var imgSrc = item.image ? item.image.replace(/(\.[^.]+)$/, '_200x$1') : '';
      html += '<div style="display:flex;gap:12px;padding:12px 0;border-bottom:1px solid var(--border-light);">';
      if (imgSrc) {
        html += '<img src="' + imgSrc + '" alt="' + item.title + '" style="width:60px;height:60px;object-fit:cover;border-radius:8px;flex-shrink:0;">';
      }
      html += '<div style="flex:1;min-width:0;">';
      html += '<p style="font-size:13px;font-weight:700;color:var(--text-primary);margin-bottom:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + item.product_title + '</p>';
      if (item.variant_title) {
        html += '<p style="font-size:11px;color:var(--text-muted);">' + item.variant_title + '</p>';
      }
      html += '<p style="font-size:13px;font-weight:700;color:var(--brand);margin-top:4px;">$' + (item.final_line_price / 100).toFixed(2) + ' <span style="font-weight:400;color:var(--text-muted);font-size:11px;">× ' + item.quantity + '</span></p>';
      html += '</div></div>';
    });
    itemsContainer.innerHTML = html;

    footer.innerHTML = '<div style="display:flex;justify-content:space-between;margin-bottom:12px;">' +
      '<span style="font-size:14px;font-weight:600;">Subtotal</span>' +
      '<span style="font-size:14px;font-weight:700;color:var(--brand);">$' + (cart.total_price / 100).toFixed(2) + '</span>' +
      '</div>' +
      '<a href="/checkout" class="btn-primary" style="width:100%;text-align:center;display:block;">Checkout</a>' +
      '<a href="/cart" style="display:block;text-align:center;font-size:12px;color:var(--text-secondary);margin-top:10px;">View full cart</a>';
  }

  // Cart drawer event listeners
  var closeBtn = document.getElementById('cartDrawerClose');
  var overlay = document.getElementById('cartDrawerOverlay');
  if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
  if (overlay) overlay.addEventListener('click', closeCartDrawer);
});
